import { createBrowserRouter } from "react-router-dom";
import Layout from "../Components/Layout";
import EmptyLayout from "../Components/EmptyLayout";
import Home from "../Screens/Home";
import Login from "../Screens/Login";
import CompanyInfo from "../Screens/CompanyInfo";
import Register from "../Screens/Register";
import DetailPageView from "../Components/DetailPageView";
import FormDetailPage from "../Components/FormDetailPage";
import MyPage from "../Screens/MyPage";
import ContactCampaign from "../Screens/Contact";
import ListInvitationDetail from "../Components/MyPage/ListInvitationDetail";
import CustomerService from "../Screens/CustomerService";
import DetailCategory from "../Components/Home/DetailCategory";
import ResetPassword from "../Screens/ResetPassword";
// import ReviewGuide from "../Components/Home/ReviewGuide";
import InterestCampaign from "../Components/MyPage/ListInterestingCampaign";
import UpdateProfile from "../Components/MyPage/UpdateProfile";
import RegisterNaver from "../Components/Register/Naver";
import LoginNaver from "../Components/Login/LoginNaver";
import ErrorPage from "../Components/ErrorPage";
import { NMapRefactored as NMap } from "../Components/Map";
import VideoPage from "../Components/VideoPage";
import Reservation from "../Screens/Reservation";
import HandleInput from "../Components/Login/FindAccount/HandleInput";

import WinningPage from "../Screens/WinningPage";
import WinningPreviewPage from "../Screens/WinningPreviewPage";
import Privacy from "../Screens/Privacy";
import FamtourDetailPage from "@/Screens/FamtourDetailPage";

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/detailFamtour/:id", // Dummy route
          element: <FamtourDetailPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/",
          element: <Home />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/review-guide/:secretkey",
          element: <WinningPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/login",
          element: <Login />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/login/naver",
          element: <LoginNaver />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/register",
          element: <Register />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/register/naver",
          element: <RegisterNaver />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/detailPage/:id",
          element: <DetailPageView />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/formdetailPage/:id",
          element: <FormDetailPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/mypage",
          element: <MyPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/mypage/updateprofile",
          element: <UpdateProfile />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/mypage/detailinvitation/:id",
          element: <ListInvitationDetail />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/customerservice",
          element: <CustomerService />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/detailcategory/:label",
          element: <DetailCategory />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/reset-password",
          element: <ResetPassword />,
          errorElement: <ErrorPage />,
        },
        // {
        //   path: "/review-guide",
        //   element: <ReviewGuide />,
        //   errorElement: <ErrorPage />,
        // },
        {
          path: "/interest-campaign",
          element: <InterestCampaign />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/contact",
          element: <ContactCampaign />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/map-campaign",
          element: <NMap />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/companyinfo",
          element: <CompanyInfo />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/review-guide-register",
          element: <VideoPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/reservation",
          element: <Reservation />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/find-username",
          element: <HandleInput />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/forgot-password",
          element: <HandleInput />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/privacy",
          element: <Privacy />,
          errorElement: <ErrorPage />,
        },
      ],
    },
    {
      element: <EmptyLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/review-guide-preview",
          element: <WinningPreviewPage />,
          errorElement: <ErrorPage />,
        },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
    },
  }
);

export default router;
